import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftFoundryColor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6569 27.0375C27.6569 27.0375 27.8143 26.8126 27.8143 26.4978V17.7958C27.8143 15.8844 29.2984 13.8382 31.3896 13.2311C31.2546 12.8039 29.9505 8.48657 29.5682 7.27233C29.1859 6.01312 28.0616 3 26.6675 3C26.6675 3 26.6675 3 26.645 3C26.645 3 26.4427 3.11243 26.3527 3.29232C25.6332 4.5965 25.3184 10.0831 25.3184 14.1755V19.2573C25.9255 21.4385 27.3646 26.4978 27.477 26.7901C27.477 26.7901 27.5894 27.015 27.6794 27.015L27.6569 27.0375Z",
			fill: "url(#paint0_linear_117376_263)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6569 27.0375C27.6569 27.0375 27.8143 26.8126 27.8143 26.4978V17.7958C27.8143 15.8844 29.2984 13.8382 31.3896 13.2311C31.2546 12.8039 29.9505 8.48657 29.5682 7.27233C29.1859 6.01312 28.0616 3 26.6675 3C26.6675 3 26.6675 3 26.645 3C26.645 3 26.4427 3.11243 26.3527 3.29232C25.6332 4.5965 25.3184 10.0831 25.3184 14.1755V19.2573C25.9255 21.4385 27.3646 26.4978 27.477 26.7901C27.477 26.7901 27.5894 27.015 27.6794 27.015L27.6569 27.0375Z",
			fill: "url(#paint1_linear_117376_263)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.7638 13.0513H32.6938C29.973 13.0513 27.8144 15.5022 27.8144 17.7958V26.4979C27.8144 26.8127 27.7244 27.0375 27.657 27.0375C27.5895 27.0375 27.4546 26.8127 27.4546 26.8127C27.4546 26.8127 27.612 27.2849 27.8369 27.2849H32.2891C33.6832 27.2849 37.8656 25.9132 37.8656 21.6184V14.3105C37.8656 13.3886 37.3259 13.0738 36.7638 13.0738V13.0513Z",
			fill: "url(#paint2_linear_117376_263)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.02546 39H18.1229C23.4071 39 25.3184 34.4354 25.3184 30.4329V14.1755C25.3184 9.49844 25.7456 3 26.69 3H19.4271C17.6957 3 16.2116 4.84385 14.5251 8.57651C12.8387 12.3092 4.72128 35.2673 4.3615 36.3691C3.77687 38.1455 4.31653 38.9775 6.02546 38.9775V39Z",
			fill: "url(#paint3_linear_117376_263)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_117376_263",
				x1: 25.2959,
				y1: 15.03,
				x2: 31.3896,
				y2: 15.03,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#302EC9" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .12,
						stopColor: "#151698"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .25,
						stopColor: "#0A0B7E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .43,
						stopColor: "#090C7F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .51,
						stopColor: "#141698"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .61,
						stopColor: "#282AC4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .77,
						stopColor: "#8E8FF4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .85,
						stopColor: "#A7A6F7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .91,
						stopColor: "#CACAFB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_117376_263",
				x1: 28.3315,
				y1: 27.0375,
				x2: 28.3315,
				y2: 4.7539,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .02,
						stopColor: "#201BA6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .64,
						stopColor: "#2D29C7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#201BA6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_117376_263",
				x1: 32.6713,
				y1: 27.15,
				x2: 32.6713,
				y2: 13.2087,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#3530C3" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#6D71D1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .97,
						stopColor: "#C0BFF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E3E4FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_117376_263",
				x1: 15.4021,
				y1: 39,
				x2: 15.4021,
				y2: 2.6852,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#302EC9" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .45,
						stopColor: "#302EC9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .95,
						stopColor: "#CACAFB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#7F7EAF"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgMicrosoftFoundryColor);
export { ForwardRef as ReactComponent };
